export const fullMobile = (value, sm, options={})=>({lg:value, md:sm|| 24, sm: sm|| 24, xs: sm || 24, ...options})